module.exports = __webpack_public_path__ + "media/images/flags/1x1/tcd-515353f56302a0dc5b76a87621a83f9f.svg";